/* eslint-disable class-methods-use-this, react/no-unused-state, jsx-a11y/mouse-events-have-key-events */
import React, { Component } from 'react';
import styled from 'styled-components';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import {Map, TileLayer, FeatureGroup, Marker, Popup, withLeaflet} from 'react-leaflet';
import L from 'leaflet';
import MeasureControlDefault from 'react-leaflet-measure';
import Alert from 'react-s-alert';
import Tooltip from 'rc-tooltip';
import { OpenStreetMapProvider } from 'leaflet-geosearch';

import { Button } from '../../components/Button';

import { ToolbarStyleOveride } from './ToolbarStyleOveride';
import { WHITE, SECONDARY, SECONDARY_DARK } from '../../constants/colors';
import {
  showMesurements,
  mergeMesurements,
  handleElementCreate,
  getSingleElement,
  handleManualMeasurementsCreate,
  handleElementUpdate,
  setSingleElementID,
} from '../../actions/elements';
import { marker, pin, markerSelected, pinSelected, pinMarked } from '../../services/mapIcons';
import { calculateColorFilterColor } from '../../services/calculateColorFilterColor';

const TooltipWrapper = styled.div`
  width: 105px;
  display: flex;
  justify-content: space-between;
  > span {
    overflow: hidden;
    width: 50px;
    float: right;
    text-align: left;
    padding: 5px 0 2px;
  }
`;

const Toolbar = styled.div`
  width: 60px;
  height: 100%;
  top: 0;
  left: 0;
  bottom: 0;
  padding: 10px 0;
  position: absolute;
  border-left: 1px solid rgba(0, 0, 0, 0.14);
  z-index: 400;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
`;

const ToolbarButton = styled.button`
  width: 38px;
  height: 38px;
  background-color: ${(props) => !props.highlight ? 'rgba(0, 0, 0, .7)' : WHITE};
  display: flex;
  border: none;
  justify-content: center;
  align-items: center;

  &:hover {
    background-color: rgba(0, 0, 0, .6);
    cursor: pointer;
    border: none;
  }

  > img {
    width: 20px;
    height: 20px;
  }
`;

const MenuWrapper = styled.div`
  position: absolute;
  top: 0;
  right: ${({ open }) => open ? '100px' : 0};
  transition: all .2s ease-in-out;
  z-index: 400;
  padding: 10px 11px;
  display: flex;
`;

const MapDrawer = styled.div`
  width: ${({ open }) => open ? '100px' : '0'};
  padding: ${({ open }) => open ? '10px' : '0'};
  background-color: #fff;
  transition: all .2s ease-in-out;
  height: 100%;
  position: absolute;
  top: 0;
  right: 0;
  z-index: 400;
  box-shadow: 0 5px 13px 0 rgba(0,0,0,0.14);
`;

const SearchWrapper = styled.div`
  width: 200px;
  background-color: rgba(0, 0, 0, .7);
  margin: 0 5px;
  padding: 2px;
  position: relative;

  > input {
    width: 100%;
    height: 100%;
  }
`;

const SearchResultWrapper = styled.div`
  position: absolute;
  background-color: #fff;
  width: calc(100% - 4px);
  max-height: 250px;
  overflow-x: hidden;

  > div {
    padding: 4px;

    &:hover {
      background-color: #eee;
      cursor: pointer;
    }
  }
`;

class MapComponent extends Component {
  constructor(props) {
    super(props);
    this.measureFinish = this.measureFinish.bind(this);
    this.relocateElement = this.relocateElement.bind(this);
    this.createElement = this.createElement.bind(this);
    this.handlePoint = this.handlePoint.bind(this);
    this.toggleEdit = this.toggleEdit.bind(this);
    this.startDraw = this.startDraw.bind(this);
    this.finishDraw = this.finishDraw.bind(this);
    this.cancleDraw = this.cancleDraw.bind(this);
    this.toggleSelect = this.toggleSelect.bind(this);
    this.handleSelectElement = this.handleSelectElement.bind(this);
    this.handleToggleSatelit = this.handleToggleSatelit.bind(this);
    this.zoomIn = this.zoomIn.bind(this);
    this.zoomOut = this.zoomOut.bind(this);
    this.scrollZoom = this.scrollZoom.bind(this);
    this.handleSelectItems = this.handleSelectItems.bind(this);
    this.handleDrawerToggle = this.handleDrawerToggle.bind(this);
    this.handleCoords = this.handleCoords.bind(this);
    this.handleSearchValueChange = this.handleSearchValueChange.bind(this);
    this.handleSearchClick = this.handleSearchClick.bind(this);
    this.state = {
      drawerOpen: false,
      create: false,
      edit: false,
      relocate: false,
      draw: false,
      select: false,
      satelit: false,
      cancle: false,
      ids: [],
      position: JSON.parse(localStorage.getItem('coords')) || [45.815399, 15.966568],
      zoom: localStorage.getItem('mapZoom') || '13',
      searchValue: '',
      searchResults: [],
    };

    this.openStreetMapProvider = new OpenStreetMapProvider();
  }

  componentDidMount() {
    localStorage.setItem('mapZoom', '13');
    localStorage.setItem('coords', '[45.815399, 15.966568]');
  }

  componentDidUpdate(prevProps) {
    if (this.state.edit && prevProps.selectedElement !== this.props.selectedElement) {
      if (this.props.selectedElement && this.props.selectedElement.id) {
        const bounds = this.map.leafletElement.getBounds();
        this.props.showMesurements([
          {lat: bounds._northEast.lat, lng: bounds._northEast.lng},
          {lat: bounds._northEast.lat, lng: bounds._southWest.lng},
          {lat: bounds._southWest.lat, lng: bounds._southWest.lng},
          {lat: bounds._southWest.lat, lng: bounds._northEast.lng},
        ]);
      } else {
        Alert.warning('Please select an element first!', {timeout: 2000});
      }
    }
  }

  async handleSearchValueChange(e) {
    const text = e.target.value;
    const results = await this.openStreetMapProvider.search({ query: text });

    this.setState({
      searchValue: text,
      searchResults: results,
    });
  }

  handleSearchClick(result) {
    this.map.leafletElement.setView(new L.LatLng(result.y, result.x));
    this.setState({
      position: [result.y, result.x],
      searchResults: [],
      searchValue: '',
    })
  }

  toggleEdit() {
    if (this.props.selectedElement && this.props.selectedElement.id) {
      this.setState((prevState) => ({edit: !prevState.edit, select: !prevState.edit, ids: prevState.edit === true ? [] : prevState.ids}));
      const bounds = this.map.leafletElement.getBounds();
      this.props.showMesurements([
        {lat: bounds._northEast.lat, lng: bounds._northEast.lng},
        {lat: bounds._northEast.lat, lng: bounds._southWest.lng},
        {lat: bounds._southWest.lat, lng: bounds._southWest.lng},
        {lat: bounds._southWest.lat, lng: bounds._northEast.lng},
      ]);
    } else if (this.state.edit) {
      this.setState({edit: false});
    } else {
      Alert.warning('Please select an element first!', {timeout: 2000});
    }
  }

  createElement() {
    this.setState((prevState) => ({create: !prevState.create}));
  }

  relocateElement() {
    this.setState((prevState) => ({relocate: !prevState.relocate}));
  }

  measureFinish(mapProps) {
    setTimeout(() => {
      if (this.state.cancle) {
        this.setState({cancle: false});
      } else if (mapProps.points.length > 3) {
        this.props.mergeMesurements(this.props.selectedElement.id, mapProps.points);
      } else {
        document.querySelector('.js-cancel.cancel').click();
        Alert.warning('Please select 4 points!', {timeout: 2000});
      }
    }, 200);
  }

  zoomIn() {
    localStorage.setItem('mapZoom', `${this.state.zoom + 1}`);
    this.setState((prevState) => ({zoom: ++prevState.zoom}));
  }

  zoomOut() {
    localStorage.setItem('mapZoom', `${this.state.zoom - 1}`);
    this.setState((prevState) => ({zoom: --prevState.zoom}));
  }

  startDraw() {
    this.setState({draw: true});
    this.setState({position: this.props.selectedElement.coordinates});
    setTimeout(() => {
      document.querySelector('.js-start.start').click();
    }, 100);
  }

  finishDraw() {
    if (this.state.ids.length) {
      this.props.handleManualMeasurementsCreate(this.props.selectedElement.id, this.state.ids);
    } else {

      document.querySelector('.js-finish.finish').click();
    }
    this.setState({draw: false, ids: []});
  }

  toggleSelect() {
    this.setState({select: true});
  }

  cancleDraw() {
    document.querySelector('.js-cancel.cancel').click();
    this.setState({draw: false, cancle: true});
  }

  handleSelectItems(markerProps) {
    if (this.state.select) {
      if (this.state.ids.includes(markerProps.target.options.id)) {
        this.setState((prevState) => ({ids: prevState.ids.filter((item) => item !== markerProps.target.options.id)}));
      } else {
        this.setState((prevState) => ({ids: [...prevState.ids, markerProps.target.options.id]}));
      }
    }
  }

  handlePoint(mapProps) {
    if (this.state.create && !this.props.selectedElement) {
      this.props.handleElementCreate({lat: mapProps.latlng.lat, lon: mapProps.latlng.lng});
      this.setState({create: false});
    } else if (this.state.relocate && this.props.selectedElement) {
      const newElement = this.props.selectedElement;
      newElement.coordinates = [mapProps.latlng.lat, mapProps.latlng.lng];
      this.props.handleElementUpdate(newElement);
      this.setState({relocate: false});
    }
  }

  handleSelectElement(markerProps) {
    this.props.setSingleElementID(markerProps.target.options.id);
  }

  handleToggleSatelit() {
    this.setState((prevProps) => ({satelit: !prevProps.satelit}));
  }

  scrollZoom(props) {
    localStorage.setItem('mapZoom', `${props.zoom}`);
    this.setState({zoom: props.zoom});
  }

  handleDrawerToggle() {
    this.setState((prevState) => ({drawerOpen: !prevState.drawerOpen}));
  }

  handleCoords() {
    const lsCoords = localStorage.getItem('coords');

    return lsCoords ? JSON.parse(lsCoords) : this.state.position;
  }

  handleMouseOver(e) {
    e.sourceTarget.openPopup();
  }

  handleMouseOut(e) {
    e.sourceTarget.closePopup();
  }

  render() {
    const MeasureControl = withLeaflet(MeasureControlDefault);
    const {
      allElements, measurementPins, selectedElement, colorValues, user,
    } = this.props;
    const {
      edit, create, zoom, drawerOpen, relocate, draw, ids,
    } = this.state;
    const measureOptions = {
      position: 'topright',
      primaryLengthUnit: 'meters',
      secondaryLengthUnit: 'kilometers',
      primaryAreaUnit: 'sqmeters',
      secondaryAreaUnit: 'acres',
      activeColor: SECONDARY,
      completedColor: SECONDARY_DARK,
    };

    return (
      <ToolbarStyleOveride create={create}>
        <Map
          center={selectedElement ? selectedElement.coordinates : this.handleCoords()}
          maxZoom={19}
          onClick={this.handlePoint}
          onMeasurefinish={this.measureFinish}
          onMeasurestart={this.measureStart}
          onViewportChanged={this.scrollZoom}
          ref={(map) => this.map = map} // eslint-disable-line
          zoom={parseInt(zoom, 10)}
        >
          {/* eslint-disable react/jsx-one-expression-per-line */}
          <FeatureGroup>
            {edit && measurementPins.length ? measurementPins.map((item, i) => (
              <Marker
                icon={selectedElement ? (selectedElement.measurements.filter((el) => el.id === item.id).length > 0 ? pinSelected : this.state.ids.includes(item.id) ? pinMarked : pin) : null} // eslint-disable-line
                id={item.id}
                key={`${item.id}-mapPin-${i}`}
                onClick={this.handleSelectItems}
                onMouseout={this.handleMouseOut}
                onMouseover={this.handleMouseOver}
                position={item.coordinates}
                zIndexOffset={(selectedElement && selectedElement.measurements.filter((el) => el.id === item.id).length > 0) ? 201 : 10}
              >
                <Popup>
                  <table>
                    <tbody>
                      <tr>
                        <td>ID:</td>
                        <td>{item.id}</td>
                      </tr>
                      <tr>
                        <td>R<sub>L</sub>:</td>
                        <td>{item.rl}</td>
                      </tr>
                      <tr>
                        <td>Q<sub>d</sub>:</td>
                        <td>{item.qd}</td>
                      </tr>
                    </tbody>
                  </table>
                </Popup>
              </Marker>
            )) : null}
            {!edit && allElements ? allElements.length && allElements
              .filter((item) => item.coordinates && item.coordinates.length)
              .map((item, i) => (
                <Marker
                  icon={(selectedElement && item.id === selectedElement.id) ? markerSelected : marker}
                  id={item.id}
                  key={`${item.id}-mapMarker-${i}`}
                  onClick={this.handleSelectElement}
                  position={item.coordinates}
                  zIndexOffset={(selectedElement && item.id === selectedElement.id) ? 200 : 1}
                >
                  <Popup>
                    <TooltipWrapper>
                      <span style={{borderBottom: `4px solid ${calculateColorFilterColor(item.rl, 'rl', colorValues)}`}}>
                        <strong>
                          RL:
                        </strong>
                        {item.rl || '/'}
                      </span>
                      <span style={{borderBottom: `4px solid ${calculateColorFilterColor(item.qd, 'qd', colorValues)}`}}>
                        <strong>
                          QD:
                        </strong>
                        {item.qd || '/'}
                      </span>
                    </TooltipWrapper>
                  </Popup>
                </Marker>
              )) : null}
            <MeasureControl {...measureOptions} />
          </FeatureGroup>
          <TileLayer
            attribution='&copy; Openstreetmap France | &copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
            maxNativeZoom='19'
            maxZoom='19'
            minZoom='0'
            url={this.state.satelit ? 'https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}' : 'https://{s}.tile.openstreetmap.fr/osmfr/{z}/{x}/{y}.png'}
          />
        </Map>
        <Toolbar>
          <Tooltip
            overlay={
              <span>
                {this.state.satelit ? 'MAP' : 'SATELIT'}
              </span>
            }
            placement="right"
          >
            <ToolbarButton onClick={this.handleToggleSatelit}>
              <img
                alt="icon"
                src="/ic-map.svg"
              />
            </ToolbarButton>
          </Tooltip>
          <Tooltip
            overlay={
              <span>
                ZOOM MAP IN
              </span>
            }
            placement="right"
          >
            <ToolbarButton onClick={this.zoomIn}>
              <img
                alt="icon"
                src="/ic-zoom-in.svg"
              />
            </ToolbarButton>
          </Tooltip>
          <Tooltip
            overlay={
              <span>
                ZOOM MAP OUT
              </span>
            }
            placement="right"
          >
            <ToolbarButton onClick={this.zoomOut}>
              <img
                alt="icon"
                src="/ic-zoom-out.svg"
              />
            </ToolbarButton>
          </Tooltip>
        </Toolbar>
        {user.admin &&
          <MenuWrapper open={drawerOpen}>
            <SearchWrapper>
              <input
                onChange={this.handleSearchValueChange}
                type="text"
                value={this.state.searchValue}
              />
              <SearchResultWrapper>
                {this.state.searchResults.map((item, i) => (
                  <div
                    key={`${item.label}-${i}`}
                    onClick={() => this.handleSearchClick(item)}
                  >{item.label}</div>
                ))}
              </SearchResultWrapper>
            </SearchWrapper>
            <ToolbarButton onClick={this.handleDrawerToggle}>
              <img
                alt="icon"
                src="/ic-map-menu.svg"
              />
            </ToolbarButton>
          </MenuWrapper>
        }
        <MapDrawer open={drawerOpen}>
          <Button
            block
            disable={selectedElement}
            onClick={this.createElement}
            type={create ? 'secondary' : 'primary'}
          >
            ADD
          </Button>
          <Button
            block
            disable={!selectedElement}
            type={relocate ? 'secondary' : 'primary'}
            onClick={this.relocateElement} // eslint-disable-line
          >
            MOVE
          </Button>
          <Button
            block
            onClick={this.toggleEdit}
            type={edit ? 'error' : 'primary'}
          >
            EDIT
          </Button>
          <Button
            block
            disable={!edit || !selectedElement}
            onClick={edit && selectedElement ? this.startDraw : () => null} // eslint-disable-line
            type={draw ? 'secondary' : 'primary'}
          >
            DRAW
          </Button>
          <Button
            block
            disable={!draw && !ids.length}
            onClick={this.finishDraw}
          >
            DONE
          </Button>
          <Button
            block
            disable={!draw}
            onClick={this.cancleDraw}
          >
            CANCLE
          </Button>
        </MapDrawer>
      </ToolbarStyleOveride>
    );
  }
}

function mapStateToProps(state) {
  return {
    user: state.users,
    allElements: state.elements.allElements,
    selectedElement: state.elements.selectedElement,
    displayedElementProps: state.elements.displayedElementProps,
    measurementPins: state.elements.measurementPins,
    error: state.elements.error,
    colorValues: state.elements.colorValues,
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    showMesurements,
    setSingleElementID,
    mergeMesurements,
    handleElementCreate,
    getSingleElement,
    handleManualMeasurementsCreate,
    handleElementUpdate,
  }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(MapComponent);



// WEBPACK FOOTER //
// ./src/containers/Map/index.js